import useIsCommunityPlan from './useIsCommunityPlan';
import useIsFreeTierTenant from './useIsFreeTierTenant';

export default function useIsDeprecatedPlan(): boolean | undefined {
  const isCommunityPlan = useIsCommunityPlan();
  const isFreeTierTenant = useIsFreeTierTenant();
  return isCommunityPlan || isFreeTierTenant;
}
